"use client";

import { datadogLogs } from "@datadog/browser-logs";
import { useEffect } from "react";

export default function InitDataDogClientLogging() {
  useEffect(() => {
    if (process.env.NEXT_PUBLIC_DD_CLIENT_TOKEN) {
      datadogLogs.init({
        clientToken: process.env.NEXT_PUBLIC_DD_CLIENT_TOKEN,
        env: process.env.NEXT_PUBLIC_DD_ENV,
        site: "datadoghq.com",
        forwardConsoleLogs: ["warn", "error"],
        service: process.env.NEXT_PUBLIC_DD_SERVICE_NAME,
      });
    }
  }, []);
  return <></>;
}
